import axios from 'axios';
import {
	ServiceUrls,
	RequestStatusKeys,
	RequestStatusMutationTypes
} from '@/modules/common';

import {
	ExplorationUnitType,
	AnimalGenderType
} from '@/enums';

export const GetFeedingListAction = async ({ commit }, params) => {
	const requestStatus = RequestStatusKeys.FEEDING_LIST;
	commit(RequestStatusMutationTypes.LOADING, requestStatus);

	try {
		const response = await axios.get(ServiceUrls.FEEDING, {
			params
		});

		let responseData = response.data || [];
		let responseMeta = {};
		if (responseData.length > 0) {
			if (responseData[0].meta != null) {
				responseMeta = responseData[0].meta;
			}
			
			if (responseData[0].data != null) {
				responseData = responseData[0].data.map(feedingItem => ({
					...feedingItem,
					genderType: AnimalGenderType.getByValue(feedingItem.sgSexo),
					explorationUnitType: ExplorationUnitType.getByValue(feedingItem.sgTipoUep)
				}));
			}
		}
		const payload = {
			requestStatus,
			data: {
				data: responseData,
				meta: responseMeta
			}
		};

		commit(RequestStatusMutationTypes.SUCCESS, payload);
	} catch (error) {
		const payload = {
			requestStatus,
			error
		};
		commit(RequestStatusMutationTypes.ERROR, payload);
	}
};

export const DeleteFeedingItemAction = async ({ commit }, { id }) => {
	const requestStatus = RequestStatusKeys.FEEDING_DELETION;
	commit(RequestStatusMutationTypes.LOADING, requestStatus);

	try {
		const response = await axios.delete(ServiceUrls.FEEDING_ITEM(id));
		
		const payload = {
			requestStatus,
			data: response.data
		};

		commit(RequestStatusMutationTypes.SUCCESS, payload);
	} catch (error) {
		const payload = {
			requestStatus,
			error
		};
		commit(RequestStatusMutationTypes.ERROR, payload);
	}
};

export const GetFeedingItemAction = async ({ commit }, { id }) => {
	const requestStatus = RequestStatusKeys.FEEDING_ITEM;
	commit(RequestStatusMutationTypes.LOADING, requestStatus);

	try {
		const response = await axios.get(ServiceUrls.FEEDING_ITEM(id));
		
		let responseData = {};
		if (response.data && response.data.length && response.data[0].data) {
			responseData = response.data[0].data;
		}

		const payload = {
			requestStatus,
			data: responseData
		};

		commit(RequestStatusMutationTypes.SUCCESS, payload);
	} catch (error) {
		const payload = {
			requestStatus,
			error
		};
		commit(RequestStatusMutationTypes.ERROR, payload);
	}
};

export const SaveFeedingItemAction = async ({ commit }, { model }) => {
	const requestStatus = RequestStatusKeys.FEEDING_ITEM_SAVE;
	commit(RequestStatusMutationTypes.LOADING, requestStatus);
	
	const getSaveRequest = async (data) => {
		if (data.idArracoamento) {
			return axios.put(ServiceUrls.FEEDING_ITEM(data.idArracoamento), data);
		}
		return axios.post(ServiceUrls.FEEDING, data);
	};

	try {
		const response = await getSaveRequest(model);
		
		let responseData = {};
		if (response.data && response.data.length && response.data[0].data) {
			responseData = response.data[0].data;
		}

		const payload = {
			requestStatus,
			data: responseData
		};

		commit(RequestStatusMutationTypes.SUCCESS, payload);
	} catch (error) {
		const payload = {
			requestStatus,
			error
		};
		commit(RequestStatusMutationTypes.ERROR, payload);
	}
};